import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Button } from '@descope/page-editor-components';
import { EditorButtonSettings } from './EditorButtonSettings';

type Props = React.ComponentProps<typeof Button> & {
	// eslint-disable-next-line react/require-default-props
	'data-descope-provider'?: string;
	// eslint-disable-next-line react/require-default-props
	'data-type'?: string;
};

const EditorButton = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLButtonElement) => connect(drag(ref)),
		[connect, drag]
	);

	return <Button ref={refCb} {...props} />;
};

EditorButton.craft = {
	name: 'Button',
	props: {
		size: 'md' as Props['size'],
		variant: 'contained' as Props['variant'],
		color: 'primary' as Props['color'],
		children: 'Click Me',
		fullWidth: false,
		formNoValidate: false,
		'data-type': 'button'
	},
	custom: {
		type: 'button'
	},
	related: {
		settings: EditorButtonSettings
	}
};

export { EditorButton };
